<template>
  <div
    class="xl:w-4/5 md:w-11/12 xl:my-10 md:my-4
     md:mx-auto m-1 bg-gray-50 rounded"
  >
    <div class="flex flex-row justify-center p-4 w-full">
      <h1 class="font-semibold xl:text-xl ">Requests</h1>
    </div>
    <div class="p-4 w-auto">
      <t-alert variant="info" show v-on:hidden="setCookie" v-if="noCookie()">
        List of module requests ordered by Email.
        <br />
        Green modules represent the modules a student is requesting to add.
        <br />
        Red modules represent the modules a student is requesting to remove.
        <br />
        Grey modules represent the modules that a student is currently enrolled
        in.
        <br />
        Accepting a request does not change the college reccords, however should
        inform the student that the request was approved/denied and move the
        request to the history page.
        <br />
        Comments are optional and will be displayed to the student on
        the "my selection" page. Individual comments overwrite the
        globalComment.
        <br />
        Tip: You can use tab and space to iterate through the requests!
      </t-alert>
    </div>
    <div v-if="userModuleChoices.length">
      <div class="flex flex-wrap p-4 w-full">
        <t-button variant="error" @click="denySelection"
          >Reject Selection</t-button
        >
        &nbsp;&nbsp;
        <t-button variant="success" @click="acceptSelection"
          >Accept Selection</t-button
        >
        &nbsp;&nbsp;
        <t-button @click="unapproveSelection"
          >Unapprove Selection</t-button
        >
        &nbsp;&nbsp;
        <t-button @click="selectAll()">Select All</t-button>
        <input
          type="text"
          class="rounded-md shadow-sm h-8 float-right
           ml-auto w-32 md:w-40 m-1 lg:w-52"
          @change="updateGlobalComment($event.target.value)"
          placeholder="Global Comment"
        />
      </div>
      <div class=" p-4">
        <div class="flex flex-col">
          <div
            class="request"
            v-for="request in userModuleChoices"
            :key="request.id"
          >
            <div class="rounded-sm metadata bg-blue-200 w-full px-1">
              <div
                class="text-sm font-medium text-gray-600 uppercase float-left "
              >
                {{ request.student_number }}: {{ request.display_name }} &lt;{{
                  request.email
                }}&gt;
              </div>
              <div
                class="float-right text-sm font-medium text-gray-600 uppercase"
              >
                {{ request.stamp.replace(/T/, ' ').replace(/\..+/, '') }}
              </div>
            </div>
            <div class="flex w-full ">
              <div class="flex flex-wrap">
                <div class="flex flex-row flex-wrap" >
                  <div
                    class="rounded-sm mr-1 px-1 my-1 bg-green-200 "
                    v-for="item in getAddedModules(request)"
                    :key="item.id"
                  >
                    <div class="text-sm mod_code">+{{ item }}</div>
                    <div class="text-xs font-thin mod_title w-28">
                      {{
                        !!modulesDict.get(item)
                          ? modulesDict.get(item).substring(0, 30)
                          : ''
                      }}
                    </div>
                  </div>
                </div>

                <div class="flex flex-row flex-wrap" >
                  <div
                    class="rounded-sm mr-1 px-1 my-1 bg-red-200"
                    v-for="item in getRemovedModules(request)"
                    :key="item.id"
                  >
                    <div class="text-sm mod_code">-{{ item }}</div>
                    <div class="text-xs font-thin mod_title w-28">
                      {{
                        !!modulesDict.get(item)
                          ? modulesDict.get(item).substring(0, 30)
                          : ''
                      }}
                    </div>
                  </div>
                </div>

                <div class="flex flex-row flex-wrap" >
                  <div
                    class="rounded-sm mr-1 px-1 my-1 bg-gray-300"
                    v-for="item in getUnchangedModules(request)"
                    :key="item.id"
                  >
                    <div class="text-sm mod_code">-{{ item }}</div>
                    <div class="text-xs font-thin mod_title w-28">
                      {{
                        !!modulesDict.get(item)
                          ? modulesDict.get(item).substring(0, 30)
                          : ''
                      }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex float-right flex-shrink ml-auto">
                <div>
                  <input
                    type="text"
                    class=" rounded-md shadow-sm h-8 float-right
                   text-xs m-1 w-28 md:w-32 lg:w-40"
                    @change="updateComment($event.target.value, request)"
                    :placeholder="
                      globalComment.length > 0 ? globalComment : 'Comment'
                    "
                  />
                </div>
                <div>
                  <input
                    type="checkbox"
                    class=" rounded-md shadow-sm m-2"
                    v-bind:checked="isSelected(request)"
                    @change="selectItem($event.target.checked, request)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="font-semibold flex justify-center text-lg m-auto text-center p-4"
    >
      <span>There is no data to display.</span>
    </div>
  </div>
</template>

<script>
import Table from './Table';

export default {
  components: {
    Table,
  },
  data: () => ({
    userModuleChoices: [],
    globalComment: '',
    selected: [],
    comments: new Map(),
    modulesDict: new Map(),
  }),
  created() {
    this.getUserModuleChoices();
    this.getModulesDict();
  },
  methods: {
    selectAll: function() {
      if (this.selected.length < this.userModuleChoices.length) {
        for (let i = 0; i < this.userModuleChoices.length; i++) {
          this.selected.push(this.userModuleChoices[i]);
        }
      } else {
        this.selected = [];
      }
    },
    selectItem: function(checked, row) {
      if (checked) {
        this.selected.push(row);
      } else {
        const index = this.selected.indexOf(row);
        if (index !== -1) {
          this.selected.splice(index, 1);
        }
      }
    },

    isSelected: function(row) {
      return this.selected.includes(row);
    },
    updateComment: function(comment, row) {
      this.comments.set(row, comment);
    },
    updateGlobalComment: function(comment) {
      this.globalComment = comment;
    },
    getModulesDict() {
      fetch(
        `${process.env.VUE_APP_API_URL}/get_all_modules`,
        {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            'jwt': localStorage.getItem('jwt'),
          }),
        },
      )
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          this.modulesDict = new Map();
          const values = Object.values(res.data);
          for (let i = 0; i < values.length; i++) {
            this.modulesDict.set(values[i].mod_code, values[i].title);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    /**
     * Used to mark a students submitted options as accepted.
     * Loops through a users choices and fetches accept_selection in app.js
     * which marks the choice with true.
     */
    async acceptSelection() {
      // console.log(this.selected);
      const req = [];
      for (let i = 0; i < this.selected.length; i++) {
        const userModuleChoice = this.selected[i];
        let comment = this.comments.get(userModuleChoice);
        if (typeof comment === 'undefined' || comment.length == 0) {
          comment = this.globalComment;
        }

        req.push({
          id: userModuleChoice.id,
          added_choices: userModuleChoice.added_choices,
          email: userModuleChoice.email,
          removed_choices: userModuleChoice.removed_choices,
          comment: comment,
        });
      }
      console.log('AccseptSelection');
      console.log(req);

      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/accept_selection`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              req,
              'jwt': localStorage.getItem('jwt'),
            }),
          },
        ).then(() => {
          this.getUserModuleChoices();
          this.$vToastify.success('Accepted Selection');
        });
        res = await res.json();
        if (!res.success) {
          throw res.error;
        }
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * Used to mark a students submitted options as denyied.
     * Loops through a users choices and fetches deny_selection in app.js
     * which marks the choice with false in the db.
     */
    async denySelection() {
      const req = [];
      for (let i = 0; i < this.selected.length; i++) {
        const userModuleChoice = this.selected[i];
        let comment = this.comments.get(userModuleChoice);
        if (typeof comment === 'undefined' || comment.length == 0) {
          comment = this.globalComment;
        }

        req.push({
          id: userModuleChoice.id,
          added_choices: userModuleChoice.added_choices,
          email: userModuleChoice.email,
          removed_choices: userModuleChoice.removed_choices,
          comment: comment,
        });
      }
      console.log(req);

      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/deny_selection`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              req,
              'jwt': localStorage.getItem('jwt'),
            }),
          },
        ).then(() => {
          this.getUserModuleChoices();
          this.$vToastify.success('Selection Denied');
        });
        res = await res.json();
        if (!res.success) {
          throw res.error;
        }
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * Used to send a request back to the approval queue.
     * Loops through the selected choices and fetches unapprove_selection
     * in app.js which sets approved back to false in the db.
     */
    async unapproveSelection() {
      const req = [];
      for (let i = 0; i < this.selected.length; i++) {
        const userModuleChoice = this.selected[i];
        let comment = this.comments.get(userModuleChoice);
        if (typeof comment === 'undefined' || comment.length == 0) {
          comment = this.globalComment;
        }

        req.push({
          id: userModuleChoice.id,
          added_choices: userModuleChoice.added_choices,
          email: userModuleChoice.email,
          removed_choices: userModuleChoice.removed_choices,
          comment: comment,
        });
      }
      console.log(req);

      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/unapprove_selection`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              req,
              'jwt': localStorage.getItem('jwt'),
            }),
          },
        ).then(() => {
          this.getUserModuleChoices();
          this.$vToastify.success('Selection Unapproved');
        });
        res = await res.json();
        if (!res.success) {
          throw res.error;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getUserModuleChoices() {
      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/get_user_module_choices`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              'jwt': localStorage.getItem('jwt'),
            }),
          },
        );
        res = await res.json();
        if (!res.success) {
          throw res;
        }
        console.log(res);
        this.userModuleChoices = res.data;
        console.log(this.userModuleChoices);
      } catch (e) {
        console.log(e);
      }
    },
    setCookie() {
      this.$cookies.set('ManageRequests-infobox', 'dismissed', 'infinity');
    },
    noCookie() {
      return !(this.$cookies.get('ManageRequests-infobox') === 'dismissed');
    },
    // Calculate genuine added modules from request added/removed/current
    getAddedModules(request) {
      let current = new Set(request.current_modules.split(","))
      return request.added_choices.split(",")
        .filter((modCode) => !current.has(modCode) && modCode.length > 0)
    },
    // Calculate genuine removed modules from request added/removed/current
    getRemovedModules(request) {
      let current = new Set(request.current_modules.split(","))
      return request.removed_choices.split(",")
        .filter((modCode) => current.has(modCode) && modCode.length > 0)
    },
    // Calculate unchanged modules from request added/removed/current
    getUnchangedModules(request) {
      let added = new Set(request.added_choices.split(","))
      let removed = new Set(request.removed_choices.split(","))
      return request.current_modules.split(",")
        .filter((modCode) =>
          !added.has(modCode) && !removed.has(modCode) && modCode.length > 0
        )
    },
  },
};
</script>

<style>
.metadata::after {
  content: '';
  clear: both;
  display: table;
}
.mod_title {
  font-size: 50%;
}
</style>
